module.exports = __webpack_public_path__ + "components/GameHandbook/handbook-thumb-earth.png";